module.exports = __webpack_public_path__ + "img/logo-sebrae-sp-azul.07f27b74.svg";